// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"19fd3ea4","217":"0417fc07","327":"cf4324ce","511":"2a095e58","749":"95ea308f","755":"0e9463e2","950":"b0d3c2d9"}[chunkId] + ".chunk.css";
};